export const jsonQa =
{
    "mtServiceUrl": "/api",
    "GoogleApiWrapper": "AIzaSyBpirc3QTYyZ4M8bpx0QfWTyvPtoYELXtM"
};
  